<template>
  <section class="content-register-challenges">
    <Breadcrumb :links="links" :data="{type:  'Desafios', name:  challenges?.title, id: challenges?.id}"/>
    <form class="content-register-challenges-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12">
          <div class="content-input-default">
            <input type="text" name="title" v-model="challenge.title" value="" placeholder="Título" required/>
          </div>
        </div>
        <div class="col-12">
          <div class="content-input-default">
            <textarea name="description" v-model="challenge.description" placeholder="Descrição"></textarea>
          </div>
        </div>
        <div class="col-12" v-if="this.challenges.id">
          <div class="content-challenges">
            <div class="content-challenges-header">
              <h2>Desafios</h2>
              <button class="btn--register" type="button" @click="showModalChallenge()">
                <img class="img-fluid" src="@/assets/img/icon-add-challenges.png" alt="icon add" title="icon add"/>
              </button>
            </div>
            <div class="content-challenges-body" v-if="this.challenges?.dataTasks?.length > 0">
              <div class="row">
                <div class="col-12 col-md-6" v-for="item in this.challenges.dataTasks" :key="item.id_tc">
                  <CardChallenges :modalChallenge="item"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
    <ModalChallenge/>
    <ModalDelete/>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import CardChallenges from './components/CardChallenges';
import ModalChallenge from './components/modals/ModalChallenge';
import ModalDelete from './components/modals/ModalDelete';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
        {
          name: 'Tarefas',
          routerName: 'Tasks'
        },
        {
          name: 'Menu',
          routerName: 'MenuTasks'
        },
        {
          name: 'Cadastrar Conteúdo',
          routerName: 'RegisterContents'
        },
        {
          name: 'Desafios',
          routerName: 'Challenges'
        },
      ],
      challenge: {
        id_user: '',
        id_task: '',
        title: '',
        description: '',
      }
    }
  },
  computed: {
    ...mapGetters('Tasks', ['currentTask', 'challenges']),
    ...mapGetters('User', ['user']),
  },
  components: {
    Breadcrumb,
    CardChallenges,
    ModalChallenge,
    ModalDelete
  },
  methods: {
    ...mapActions('Tasks', ['registerChallenges', 'setEditModalChallenge']),
    async handleSubmit(){
      if (this.challenges?.id && !this.challenges?.dataTasks) {
        let messageText = 'Você deve cadastrar ao menos um desafio.'
        this.$swal.fire({ icon: 'info', html: messageText })
        return;
      }

      let message = '';
      if (this.challenges?.id) {
        message = 'Desafio editado com sucesso!';
        this.challenge.id = this.challenges.id;
      } else {
        message = 'Desafio cadastrado com sucesso!'
      }
      this.challenge.id_user = this.user.id;
      this.challenge.id_task = this.currentTask.id;

      console.log('CHALLENGE', this.challenge);

      await this.registerChallenges(this.challenge);
      // this.$router.push({ name: 'RegisterContents' })
      this.$swal.fire({
        icon: 'success',
        html: message,
      })
    },
    async showModalChallenge() {
      this.$bvModal.show('modal-challenge');
    }
  },
  async mounted() {
    if (Object.keys(await this.currentTask).length > 0){
      this.links[0].name = this.currentTask.name;
    }
    if (Object.keys(await this.challenges).length > 0) {
      this.challenge = this.challenges;
      this.links[3].name = this.challenges.title;
    }
  }
}
</script>

<style lang="scss" scoped>
.content-register-challenges {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.content-challenges {
  margin-top: 20px;
  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    margin-bottom: 30px;
    h2 {
      font-size: 20px;
      font-family: 'Font Semibold';
      color: var(--red-light);
      margin-bottom: 0;
    }
    .btn--register {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: 0;
      border: 1px solid transparent;
      box-shadow: 0px 1px 3px rgb(0,0,0,0.25);
      border-radius: 10px;
      transition: 500ms;
      &:hover {
        cursor: pointer;
        border-color: var(--yellow);
      }
    }
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px){
    margin-top: 50px;
  }
}
</style>
